// 与 postcss-pxtorem 配置保持一致，rootValue=100
export function px2rem(px: number, base: number = 100): string {
  if (typeof px !== 'number') return px;
  return `${px / base}rem`;
}
